import { useCallback, useEffect } from 'react';

import { useLastInteractedStoreMachine } from './useLastInteractedStoreMachine';

import type { LastInteractedStore } from './machine/LastInteractedStore.machine.types';

/**
 * Sets the last interacted menu store if it is resolved.
 */
export const useSetLastInteractedMenuStore = (
  lastInteractedMenuStore: LastInteractedStore = {},
) => {
  const { send } = useLastInteractedStoreMachine();

  const {
    restaurantId,
    restaurantName,
    restaurantSlug,
    addressId,
    deliveryFee,
    vendor,
    vendorRestaurantId,
  } = lastInteractedMenuStore;

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const setLastInteractedMenuStore = useCallback(
    (store: LastInteractedStore = {}) => {
      const {
        restaurantId,
        restaurantName,
        restaurantSlug,
        addressId,
        deliveryFee,
        vendor,
        vendorRestaurantId,
      } = store;

      if (!restaurantSlug && !addressId) return;

      send({
        type: 'SET_LAST_INTERACTED_MENU_STORE',
        store: {
          restaurantId,
          restaurantName,
          addressId,
          restaurantSlug,
          deliveryFee,
          vendor,
          vendorRestaurantId,
        },
      });
    },
    [send],
  );

  // ─── Effects ───────────────────────────────────────────────────────────────

  useEffect(() => {
    setLastInteractedMenuStore({
      restaurantId,
      restaurantName,
      addressId,
      restaurantSlug,
      deliveryFee,
      vendor,
      vendorRestaurantId,
    });
  }, [
    restaurantId,
    restaurantName,
    addressId,
    restaurantSlug,
    deliveryFee,
    vendor,
    vendorRestaurantId,
    setLastInteractedMenuStore,
  ]);

  return setLastInteractedMenuStore;
};
